import React, { useLayoutEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useAppSelector } from '../../../store';
import { Card, List, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconHomePlus } from '@tabler/icons-react';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { Link, useParams } from 'react-router';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import CusButton from '../../../components/material-ui/CusButton';
import CasinoMenu from './CasinoMenu';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import CusLink from '../../../components/material-ui/CusLink';
import { ENUM_STRING_MENU, TEST_MODE } from '../../../enums/enums';
import Error from '../../authentication/Error';
import SettingMenuCasino from './SettingMenuCasino';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';

export default function SettingsCasinos() {
  const { t } = useTranslation();
  const { casinoId } = useParams();
  const { isLessTablet } = useBootstrapSize();
  const casinos = useAppSelector((state) => state.user.info.casino);
  const customizer = useAppSelector((state) => state.customizer);
  const isCreate = useAppSelector((state) => state.user.casinoActions.create);
  const hiddenMenuItems = useAppSelector((state) => state.info.hiddenMenuItems);

  const casinoListRef = useRef();

  const br = `${customizer.borderRadius}px`;
  const [selectCasino, setSelectCasino] = useState();

  const casino = casinos.find((el) => el.id == selectCasino);
  const casinoName = casino?.casinoName;
  const isPageHide = hiddenMenuItems.includes(ENUM_STRING_MENU.casinoSetting);

  useLayoutEffect(() => {
    if (casinos.find((el) => el.id == casinoId)) {
      setSelectCasino(casinoId);
    }
  }, [casinoId, casinos]);

  const CasinoItemText = ({ casino }) => {
    const botName = casino.botName ? '@' + casino.botName : '-';
    const casinoName = casino.casinoName ? `${casino.casinoName} (${casino.id})` : '-';
    const groupName = casino.groupName ? `${casino.groupName} (${casino.groupId})` : '-';
    const domainName = casino.domain || '';

    const TypographyText2 = ({ children }) => (
      <TypographyText
        color="textSecondary"
        component={'span'}
        fontSize={12}
        sx={{ minWidth: '50px', display: 'inline-flex' }}>
        {children}
      </TypographyText>
    );

    return (
      <Stack gap={0.25}>
        <TypographyText fontSize={14} fontWeight={600}>
          <TypographyText2>{t('Casino')}:</TypographyText2> {casinoName}
        </TypographyText>
        <TypographyText fontSize={13}>
          <TypographyText2>{t('Group')}:</TypographyText2> {groupName}
        </TypographyText>
        <TypographyText fontSize={13}>
          <TypographyText2>{t('Domain')}:</TypographyText2>{' '}
          <ShowContainer condition={domainName} plug={'-'}>
            <CusLink
              component="span"
              linkComponent="a"
              target="_blank"
              href={'https://' + domainName}
              text={domainName}
            />
          </ShowContainer>
        </TypographyText>
        <TypographyText fontSize={13}>
          <TypographyText2>{t('Bot')}:</TypographyText2>
          <CusLink
            component="span"
            linkComponent="a"
            target="_blank"
            href={`https://t.me/${botName.replace('@', '')}`}
            text={botName}
          />
        </TypographyText>
      </Stack>
    );
  };

  return (
    <ShowContainer condition={!isPageHide} plug={<Error height="calc(100svh - 100px)" />}>
      <CusPageCardContainer title={'Casino settings'}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Card sx={{ height: '100%' }}>
              <Stack ref={casinoListRef} gap={1}>
                <Stack
                  gap={1}
                  justifyContent={'space-between'}
                  direction={isLessTablet ? 'column' : 'row'}>
                  <Typography variant="body1" fontWeight={600}>
                    {t('Select casino')}
                  </Typography>

                  <ShowContainer condition={isCreate || TEST_MODE}>
                    <CusButton
                      startIcon={<IconHomePlus />}
                      text="Create casino"
                      variant="outlined"
                      LinkComponent={Link}
                      to="/settings/casino/create"
                    />
                  </ShowContainer>
                </Stack>
                <List>
                  {casinos.map((casino) => {
                    const botName = casino.botName ? '@' + casino.botName : casino.botName;

                    return (
                      <ListItemButton
                        sx={{ borderRadius: br }}
                        selected={casino.id == selectCasino}
                        onClick={() => setSelectCasino(casino.id)}
                        key={casino.id}>
                        <ListItemText primary={<CasinoItemText casino={casino} />} />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Stack>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <ErrorBoundary>
              <SettingMenuCasino
                casinoListRef={casinoListRef}
                casinoName={casinoName}
                selectCasino={selectCasino}
              />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </CusPageCardContainer>
    </ShowContainer>
  );
}
